import type { IdeaDetail, Industry } from '@/api/types';

/** The current industry as a disabled option when it is not one people may choose: pending review, or no longer active. */
function currentOptionLabel(current: NonNullable<IdeaDetail['industry']>, choices: Industry[]): string | null {
  if (current.status === 'pending') return `${current.name} (pending review)`;
  if (current.status === 'approved' && !choices.some((i) => i.id === current.id)) return `${current.name} (inactive)`;
  return null;
}

export function IndustryOptions({ current, industries }: { current: IdeaDetail['industry']; industries: Industry[] | undefined }) {
  // People choose approved, active industries; a pending one stays visible as the current value.
  const choices = (industries ?? []).filter((i) => i.status === 'approved' && i.is_active);
  const currentLabel = current ? currentOptionLabel(current, choices) : null;
  return (
    <>
      {current && currentLabel && (
        <option value={current.id} disabled>
          {currentLabel}
        </option>
      )}
      <option value="">Unassigned</option>
      {choices.map((i) => (
        <option key={i.id} value={i.id}>{i.name}</option>
      ))}
    </>
  );
}
